export default {
    control: (provided, state) => ({
        ...provided,
        background: 'var(--background-color-white)',
        border: `1px solid ${state.isFocused ? 'var(--border-color-branded-primary)' : 'var(--border-color-neutral-primary)'}`,
        borderRadius: 'var(--radius-m)',
        boxSizing: 'border-box',
        boxShadow: 'none',
        color: 'var(--text-color-neutral-primary)',
        cursor: 'pointer',
        fontFamily: 'var(--font-family)',
        fontSize: 'var(--font-m)',
        height: '40px',
        minWidth: '12rem',
        outline: 'none',
        transition: 'border-color 0.2s ease-in-out',
        width: '100%',
        '&:hover': {
            borderColor: 'var(--border-color-neutral-primary)',
        },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999999 }),
    menu: (provided) => ({
        ...provided,
        borderRadius: 'var(--radius-m)',
        border: '1px solid var(--border-color-neutral-secondary)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        zIndex: 100,
    }),
    valueContainer: (provided) => ({
        ...provided,
        display: 'flex',
        flex: 1,
        height: '100%',
        overflow: 'hidden',
        padding: 0,
        position: 'relative',
        '.react-select__input-container': {
            margin: '0',
            padding: '0',
        },
    }),
    singleValue: () => ({
        color: 'var(--text-color-neutral-primary)',
        fontSize: 'var(--font-m)',
        left: 'var(--space-s)',
        overflow: 'hidden',
        position: 'absolute',
        right: 0,
        textAlign: 'left',
        textOverflow: 'ellipsis',
        top: '50%',
        transform: 'translateY(-50%)',
        whiteSpace: 'nowrap',
    }),
    placeholder: () => ({
        color: 'var(--text-color-neutral-tertiary)',
        fontSize: 'var(--font-m)',
        left: 'var(--space-s)',
        overflow: 'hidden',
        position: 'absolute',
        right: 0,
        textAlign: 'left',
        textOverflow: 'ellipsis',
        top: '50%',
        transform: 'translateY(-50%)',
        whiteSpace: 'nowrap',
    }),
    input: (provided) => ({
        ...provided,
        padding: '0',
        margin: '0',
        color: 'var(--text-color-neutral-primary)',
        fontSize: 'var(--font-m)',
        textDecoration: 'none',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: 'var(--text-color-neutral-secondary)',
        padding: '0 var(--space-xs)',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    option: (provided, state) => ({
        ...provided,
        background: state.isSelected ? 'var(--background-color-branded-light-primary)' : 'var(--background-color-white)',
        color: state.isSelected ? 'var(--text-color-branded-secondary)' : 'var(--text-color-neutral-primary)',
        cursor: 'pointer',
        fontFamily: 'var(--font-family)',
        fontSize: 'var(--font-m)',
        '&:hover': {
            background: 'var(--background-color-neutral-primary-hover)',
            color: 'var(--text-color-neutral-primary)',
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: 'var(--background-color-branded-light-primary)',
        color: 'var(--text-color-branded-secondary)',
        borderRadius: 'var(--radius-l)',
        fontSize: 'var(--font-xs)',
        margin: '0',
        padding: 'var(--space-xxs) var(--space-xs)',
        userSelect: 'none',
        whiteSpace: 'nowrap',
        alignItems: 'center',
    }),
    multiValueLabel: () => ({}),
    multiValueRemove: (provided) => ({
        ...provided,
        cursor: 'pointer',
        margin: '0',
        padding: '0',
        marginLeft: 'var(--space-xxs)',
        '&:hover': {
            background: 'none',
        },
    }),
};
